/**
 * ExecPro360 - Copyright (c) 2026 Emmanuel TESTE
 * Tous droits réservés - Logiciel propriétaire
 */
import LegalLayout from "../components/LegalLayout";
import {
  PUBLISHER_NAME, PUBLISHER_LEGAL_FORM, PUBLISHER_RCS, CONTACT_EMAIL, CGU_VERSION, CGU_DATE,
} from "../config/legal";

export default function Terms() {
  return (
    <LegalLayout current="cgu" title="Conditions Générales d'Utilisation" updated={<>Version {CGU_VERSION} — {CGU_DATE} · ExecPro360</>}>
      <h2>1. Objet</h2>
      <p>
        Les présentes CGU régissent l'accès et l'utilisation d'ExecPro360, plateforme SaaS de
        gestion comptable et de facturation pour dirigeants de PME, éditée par {PUBLISHER_NAME},
        {' '}{PUBLISHER_LEGAL_FORM} ({PUBLISHER_RCS}) — mentions légales détaillées sur la page dédiée.
      </p>

      <h2>2. Inscription et essai gratuit</h2>
      <p>
        L'inscription est ouverte sans carte bancaire et donne accès à un essai gratuit de 14
        jours, avec l'ensemble des fonctionnalités du service. L'utilisateur est seul responsable
        de la confidentialité de ses identifiants ; tout accès depuis son compte est réputé
        effectué par lui.
      </p>

      <h2>3. Fin de l'essai</h2>
      <p>
        À l'expiration des 14 jours, en l'absence d'abonnement payant actif, le compte passe en
        lecture seule : les données restent consultables et exportables, mais ne peuvent plus être
        créées ni modifiées. Sept jours plus tard (21 jours après le début de l'essai), la société
        est archivée. Aucune suppression n'intervient automatiquement à ce stade — une suppression
        réelle nécessite une procédure manuelle de notre part. Un export des données comptables
        (FEC) et de la liste des factures (CSV) reste possible depuis le compte jusqu'à l'archivage.
      </p>

      <h2>4. Abonnements payants</h2>
      <p>
        Les tarifs sont ceux affichés sur{' '}
        <a href="https://execpro360.com">execpro360.com</a>. L'essai de 14 jours
        est gratuit et sans carte bancaire. La souscription payante sera proposée à l'issue de
        l'essai.
      </p>

      <h2>5. Obligations de l'utilisateur</h2>
      <ul>
        <li>Exactitude des données saisies — l'utilisateur reste seul responsable de la conformité de sa comptabilité et de ses obligations fiscales</li>
        <li>Usage strictement professionnel et conforme à la loi</li>
        <li>Interdiction de tenter d'accéder aux données d'un autre abonné</li>
        <li>Interdiction de reverse-engineering, décompilation ou extraction non autorisée du code</li>
      </ul>

      <h2>6. Données et propriété</h2>
      <p>
        L'utilisateur conserve l'entière propriété de ses données. L'éditeur ne les cède pas à des
        tiers. La politique de confidentialité détaille les traitements effectués et les
        sous-traitants impliqués, notamment Mistral AI (France) pour les fonctions
        d'intelligence artificielle.
      </p>

      <h2>7. Propriété intellectuelle</h2>
      <p>
        ExecPro360, son code source, ses interfaces et ses algorithmes sont la propriété exclusive
        de l'éditeur. Toute reproduction ou utilisation non autorisée est interdite.
      </p>

      <h2>8. Limitation de responsabilité</h2>
      <p>
        ExecPro360 est un outil d'aide à la gestion et au pilotage financier. L'éditeur met en
        œuvre des moyens raisonnables pour assurer la disponibilité et la fiabilité du service,
        sans garantie de résultat. L'éditeur ne saurait être tenu responsable des décisions prises
        sur la base des données affichées, ni des interruptions de service liées à un cas de force
        majeure, une maintenance, ou un tiers (hébergeur, fournisseur de paiement…).
      </p>

      <h2>9. Droit applicable</h2>
      <p>
        Les présentes CGU sont soumises au droit français. Tout litige relève, à défaut de
        résolution amiable, de la compétence des tribunaux français.
      </p>

      <h2>10. Modification des CGU</h2>
      <p>
        L'éditeur se réserve le droit de modifier les présentes CGU, notamment lors de l'ouverture
        des abonnements payants. Les utilisateurs seront informés de toute modification
        substantielle.
      </p>

      <h2>11. Contact</h2>
      <p>
        Pour toute question relative aux présentes CGU :{' '}
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
      </p>
    </LegalLayout>
  );
}
